import { createContext, ReactNode, useContext } from 'react'

interface PageHeaderContext {
  exportDashboardComponentCode: string | undefined
  isExportSchedulingOpen: boolean
  setIsExportSchedulingOpen: (isOpen: boolean) => void
  printModeAllowed: boolean
}

interface PageHeaderProviderProps extends PageHeaderContext {
  children: ReactNode
}

const PageHeaderContext = createContext<PageHeaderContext | null>(null)

export const PageHeaderProvider = ({
  children,
  exportDashboardComponentCode,
  isExportSchedulingOpen,
  setIsExportSchedulingOpen,
  printModeAllowed,
}: PageHeaderProviderProps) => {
  return (
    <PageHeaderContext.Provider
      value={{
        exportDashboardComponentCode,
        isExportSchedulingOpen,
        setIsExportSchedulingOpen,
        printModeAllowed,
      }}
    >
      {children}
    </PageHeaderContext.Provider>
  )
}

export const usePageHeaderContext = () => {
  const context = useContext(PageHeaderContext)
  if (!context) {
    throw new Error('usePageHeaderContext must be used within a PageHeaderProvider')
  }
  return context
}
